
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useGlobalData } from "../context/GlobalDataContext";
import { Link } from "react-router-dom";
import "./ResultTablePage.css";

const TABLE_PAGE_LIMIT = 29;


function ResultTablePage() {
  const { threeTable, fetchThreeTableSection } = useGlobalData();
  const [isUpdating, setIsUpdating] = useState(false);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [localResults, setLocalResults] = useState([]);
  // Removed unused initialLoadDone state
  const tableWrapperRef = useRef(null);

  // Initial + paginated load
  const loadResults = useCallback(async (nextOffset = 0, isInitial = false) => {
    setIsUpdating(true);
    try {
      await fetchThreeTableSection("results", false, {
        preferLoadedData: false,
        fetchIfPartial: false,
        showLoading: false,
        skipLoader: !isInitial,
        limit: TABLE_PAGE_LIMIT,
        offset: nextOffset
      });
      setHasMore(true);
      setOffset(nextOffset);
      // Removed setInitialLoadDone as it's unused
    } finally {
      setIsUpdating(false);
    }
  }, [fetchThreeTableSection]);

  useEffect(() => {
    if (offset === 0) {
      setLocalResults(threeTable.results || []);
      setHasMore((threeTable.results || []).length === TABLE_PAGE_LIMIT);
      setOffset((threeTable.results || []).length);
    }
  }, [threeTable.results, offset]);


  // On mount: agar global state me data hai to wahi use karo, warna API call karo (aur skeleton dikhao)
  useEffect(() => {
    if ((threeTable.results || []).length > 0) {
      setLocalResults(threeTable.results);
      setHasMore(threeTable.results.length === TABLE_PAGE_LIMIT);
      setOffset(threeTable.results.length);
      // Removed setInitialLoadDone as it's unused
    } else {
      loadResults(0, true); // skipLoader: false for skeleton
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!hasMore || isUpdating) return;
      const el = tableWrapperRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      if (rect.bottom <= window.innerHeight + 200) {
        loadResults(offset, false); // skipLoader: true for scroll
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasMore, isUpdating, offset, loadResults]);

  const results = localResults;
  const jobs = threeTable.jobs || [];
  // ✅ Get job title by slug
  const getJobTitle = (jobSlug) => {
    const job = jobs.find(j => j.slug === jobSlug);
    return job ? job.title : jobSlug;
  };
  return (
    <div className="result-table-container">
      <h2>Result Table</h2>
      <div
        className="result-table-wrapper"
        ref={tableWrapperRef}
        style={{ overflowY: "auto", maxHeight: "1400px" }}
      >
        <table className="result-table">
          <thead>
            <tr>
              <th>Job Title</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            {results.map((item, i) => (
              <tr key={i}>
                <td className="job-title-cell">{getJobTitle(item.jobSlug)}</td>
                <td>
                  <Link to={`/mform/${item.jobSlug || item.slug}`} className="result-link">Result View</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Status messages below the table */}
      {isUpdating && results.length === 0 && (
        <p style={{ marginTop: "10px", textAlign: "center", color: "#1d4ed8", fontWeight: 600 }}>
          Loading results...
        </p>
      )}
      {isUpdating && results.length > 0 && (
        <p style={{ marginTop: "10px", textAlign: "center", color: "#1d4ed8", fontWeight: 600 }}>
          Loading more results...
        </p>
      )}
      {!isUpdating && !hasMore && results.length > 0 && (
        <p style={{ marginTop: "10px", textAlign: "center", color: "#888" }}>
          No more results.
        </p>
      )}
    </div>
  );
}

export default ResultTablePage;
